import React, {useState, useEffect, useCallback} from "react";
import {useOutletContext} from "react-router";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import {config} from "../../config";
import {IconButton} from "@mui/material";
import {NavigateBefore, NavigateNext, RotateLeft} from "@mui/icons-material";

export const SeasonPicker = ({setterFunction, seasonYearsOverride, includeCurrent = true}) => {
    const {currentLeague, currentAuction} = useOutletContext();
    const [seasonYears, setSeasonYears] = useState(config.seasonYears);
    const [anchorElSeason, setAnchorElSeason] = useState(null);
    const [selectedSeasonIndex, setSelectedSeasonIndex] = useState(null);

    const initialSeasonYear = useCallback(() => {
        if (seasonYearsOverride) {
            return seasonYearsOverride.at(-1);
        } else {
            if (includeCurrent) {
                return currentAuction.season_year;
            } else {
                if (['PREDRAFT', 'DRAFT'].includes(currentLeague.season_phase)) {
                    return currentAuction.season_year - 1;
                } else {
                    return currentAuction.season_year;
                }
            }
        }
    }, [currentLeague, currentAuction.season_year, seasonYearsOverride, includeCurrent]);

    useEffect(() => {
        if (seasonYearsOverride) {
            setSeasonYears(seasonYearsOverride);
        }
    }, [seasonYearsOverride]);

    useEffect(() => {
        const seasonYear = initialSeasonYear();
        setSelectedSeasonIndex(seasonYears.indexOf(seasonYear));
        setterFunction(seasonYear);
        // eslint-disable-next-line
    }, [seasonYears, initialSeasonYear]);

    const handleClickSeason = (event) => {
        setAnchorElSeason(event.currentTarget);
    };

    const handleSeasonMenuItemClick = (event, index) => {
        setSelectedSeasonIndex(index);
        setAnchorElSeason(null);
    };

    const handleClose = () => {
        setAnchorElSeason(null);
    };

    const handlePreviousSeason = () => {
        if (selectedSeasonIndex !== 0) {
            setterFunction(seasonYears[selectedSeasonIndex - 1]);
            setSelectedSeasonIndex(selectedSeasonIndex - 1);
        }
    };

    const handleNextSeason = () => {
        if (selectedSeasonIndex !== seasonYears.length - 1) {
            setterFunction(seasonYears[selectedSeasonIndex + 1]);
            setSelectedSeasonIndex(selectedSeasonIndex + 1);
        }
    };

    const handleSubmit = () => {
        setterFunction(seasonYears[selectedSeasonIndex]);
    };

    const handleReset = () => {
        const seasonYear = initialSeasonYear(); //TODO: this will be wrong in reg season... will set to current instead of respecting override on wins pool page
        setSelectedSeasonIndex(seasonYears.indexOf(seasonYear));
        setterFunction(seasonYear);
    };

    return (
        <div style={{paddingTop: 15, paddingBottom: 15}}>
            <IconButton color="inherit" style={{height: 25}} onClick={handlePreviousSeason}>
                <NavigateBefore/>
            </IconButton>
            <IconButton color="inherit" style={{height: 25}} onClick={handleNextSeason}>
                <NavigateNext/>
            </IconButton>
            Season:
            <Button style={{backgroundColor: "lightgray", height: 25, marginLeft: 10, marginRight: 10}}
                    onClick={handleClickSeason}>{seasonYears[selectedSeasonIndex]}</Button>
            <Menu id="seasonPickerMenu" anchorEl={anchorElSeason} keepMounted open={Boolean(anchorElSeason)}
                  onClose={handleClose}>
                {seasonYears.map((seasonYear, index) => (
                    <MenuItem key={seasonYear} selected={index === selectedSeasonIndex}
                              onClick={(event) => handleSeasonMenuItemClick(event, index)}>{seasonYear}</MenuItem>
                ))}
            </Menu>
            <Button variant="contained" color="primary" style={{height: 25}} onClick={handleSubmit}>Select</Button>
            <IconButton color="inherit" style={{height: 25}} onClick={handleReset}>
                <RotateLeft/>
            </IconButton>
        </div>
    );
}